const es = {
  placeholderText: "Ingrese",
  closeContentText: "¿Terminar conversación actual?",
  cancelText: "Cancelar",
  okText: "Aceptar",
  loadingAnswerQuestions:
    "Respondiendo su pregunta anterior. Espere para enviar.",
  networkAnomalyText: "Error de red. Por favor, inténtelo más tarde.",
  errorText: "​​Error del servidor",
  messageTooShort: "Se deben ingresar al menos dos caracteres.",
  messageTooLong: "No puede exceder 200 caracteres.",
  systemErrorText:
    "Error del sistema. Por favor, inténtelo de nuevo más tarde.​​",
  fileSizeExceeded: "Un archivo no puede superar los {maxSize}MB.",
  abnormalDisconnectionText: "Conexión perdida. Reconectando...",
  evaluationText: "¡Su opinión nos ayuda a mejorar!",
  emailLabel: "Correo Electrónico​",
  emailPlaceholder: "Ingrese su correo electrónico",
  emailErrorText: "Formato de correo inválido.",
  productLabel: "Producto",
  productPlaceholder: "Seleccione un producto",
  problemLabel: "Descripción del problema",
  problemPlaceholder: "Describa el problema con detalles",
  submitText: "Enviar",
  submitField:
    "Lo sentimos, el envío falló. Por favor, inténtelo de nuevo más tarde.",
  thankText:
    "¡Gracias por su colaboración! ¡Nos pondremos en contacto con usted lo antes posible! ¡Por favor, revise su correo electrónico o {link}​ para ver las respuestas!",
  clickHere: "haga clic aquí​​",
  thankEvaluation: "​​​¡Gracias por su evaluación!",
  codeLabel: "Código de verificación",
  codePlaceholder: "Por favor, introduzca el código de verificación",
  submittedSuccessfully: "Enviado correctamente",
  supportContact: "Contacto de Soporte",
  stillCancel: "Cancelar de todos modos",
  useDiscount: "Usar descuento",
  pauseDuration: "Duración de la pausa",
  uploadAttachment: "Subir archivo adjunto",
};
export default es;
